var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div'):_c('div',[_c('b-alert',{attrs:{"show":"","fade":""}},[_vm._v("Debe logearse al sistema")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }